export const cmdReplyTopic = (gatewayId, sessionId, manufacturer = "+") => `evt/ecs-v0/${process.env.REACT_APP_ENVIRONMENT}/${manufacturer}/${gatewayId}/command/${sessionId}`;

export const eventsTopic = (gatewayId, manufacturer = "+") => `evt/ecs-v0/${process.env.REACT_APP_ENVIRONMENT}/${manufacturer}/${gatewayId}/status`;

export const telemetryTopic = (gatewayId, manufacturer = "+") => `evt/ecs-v0/${process.env.REACT_APP_ENVIRONMENT}/${manufacturer}/${gatewayId}/telemetry`;

export const otaTopic = (gatewayId, manufacturer = "+") => `evt/ecs-v0/${process.env.REACT_APP_ENVIRONMENT}/${manufacturer}/${gatewayId}/ota`;